import UIComponent from './UIComponent';
import EventBus from "./eventbus.js";

const ElioJSONSchemaConverter = {
    install(Vue, options) {
        var defaultOptions = {
            debug: true
        };

        options = {...defaultOptions, ...options};

        var uiSchema = {};

        var schema = null;

        var payload = null;

        var globalData = null;

        var model = {};

        function log(message) {
            if(options.debug) {
                console.log('ElioJSONSchemaConverter: ', message);
            }
        }

        /**
         * Generates the main UI object generally required for the UI schema in the form of a DIV container
         */
        function generateUISchemaWrapper() {
            uiSchema = new UIComponent("div");
            uiSchema.addFieldOption("class", ["row"]);
        }

        /**
         * Iterates over all form fields and triggers the UI schema generation per form field.
         */
        function initializeFormFields(schema) {
            var requiredFields = schema.required;

            for (var schemaProperty in schema.properties) {
                if(schema.properties.hasOwnProperty(schemaProperty)) {
                    schema.properties[schemaProperty].elementId = schemaProperty;
                }
            }

            const properties = Object.values(schema.properties).sort((a, b) => a.order - b.order);

            for(var property in properties) {
                var isRequired = requiredFields.includes(property.elementId);

                if(properties[property].ui.hasOwnProperty("before")) {
                    var before = generateStaticContentComponent(properties[property].ui.before);

                    if(before) {
                        uiSchema.addChild(before);
                    }
                }

                var column = new UIComponent("div");

                if(properties[property].ui.hasOwnProperty("grid")) {
                    column.addFieldOption("class", properties[property].ui.grid);
                }

                if(properties[property].ui.hasOwnProperty("prepend")) {
                    var prepend = generateStaticContentComponent(properties[property].ui.prepend);

                    if(prepend) {
                        column.addChild(prepend);
                    }
                }

                var tempComponent = null;

                switch (properties[property].ui.type) {
                    case "text":
                    case "number":
                    case "email":
                        tempComponent = generateTextFieldComponent(properties[property], isRequired);
                        break;
                    case "date":
                        tempComponent = generateDateComponent(properties[property], isRequired);
                        break;
                    case "checkbox":
                        tempComponent = generateCheckboxComponent(properties[property], isRequired);
                        break;
                    case "single-select":
                        tempComponent = generateSelectComponent(properties[property], isRequired);
                        break;
                    case "file":
                        tempComponent = generateFileComponent(properties[property], isRequired);
                        break;
                    case "hidden":
                        tempComponent = generateHiddenComponent(properties[property], isRequired);
                        break;
                    case "offer-page":
                        tempComponent = generateOfferPageComponent(properties[property], false);
                        break;
                }

                if(tempComponent) {
                    column.addChild(tempComponent);
                }

                if(properties[property].ui.hasOwnProperty("append")) {
                    var append = generateStaticContentComponent(properties[property].ui.append);

                    if(append) {
                        column.addChild(append);
                    }
                }

                uiSchema.addChild(column);


                if(properties[property].ui.hasOwnProperty("after")) {
                    var after = generateStaticContentComponent(properties[property].ui.after);

                    if(after) {
                        uiSchema.addChild(after);
                    }
                }
            }
        }

        function generateStaticContentComponent(schemaProperty) {
            //schemaProperty MUST contain the following keys: innerHTML, component
            //schemaProperty MAY contain the following keys: classNames

            if(schemaProperty.hasOwnProperty("innerHTML") && schemaProperty.hasOwnProperty("component")) {
                var staticContentComponent = new UIComponent(schemaProperty.component);
                staticContentComponent.addFieldOption("domProps", {"innerHTML": schemaProperty.innerHTML});

                if(schemaProperty.hasOwnProperty("classNames")) {
                    staticContentComponent.addFieldOption("class", schemaProperty.classNames);
                }

                return staticContentComponent;
            }

            return false;
        }

        function generateTooltipComponent(schemaProperty) {
            //schemaProperty MUST contain the following keys: text
            //schemaProperty MAY contain the following keys: icon

            if(schemaProperty.hasOwnProperty("text")) {

                var button = new UIComponent("q-btn");

                button.addFieldOption("slot", "after");
                button.addFieldOptionProperty("round", "round");
                button.addFieldOptionProperty("dense", "dense");
                button.addFieldOptionProperty("flat", "flat");

                if(schemaProperty.hasOwnProperty("icon")) {
                    button.addFieldOptionProperty("icon", schemaProperty.icon);
                } else {
                    button.addFieldOptionProperty("icon", "info");
                }

                var tooltip = new UIComponent("q-tooltip");

                tooltip.addFieldOptionProperty("anchor", "center right");
                tooltip.addFieldOptionProperty("self", "center left");

                var tooltipText = new UIComponent("span");

                tooltipText.addFieldOption("domProps", {"innerHTML": schemaProperty.text});

                tooltip.addChild(tooltipText);

                button.addChild(tooltip);

                return button;
            }
            return false;
        }

        function generateValidationComponent(message, modelName, conditions) {
            var validationComponent = new UIComponent("span");

            validationComponent.addRootProperty("errorHandler", true);
            validationComponent.addFieldOption("slot", "error");
            validationComponent.addFieldOption("domProps", {"innerHTML": message});
            validationComponent.addDisplayOption("model", modelName);
            validationComponent.addDisplayOption("schema", conditions);

            return validationComponent;
        }

        function generateValidationComponents(schemaProperty, modelName, isRequired) {
            var validationProperties = schemaProperty.ui.validation;
            var validators = [];

            // Handle form validation for required fields (differs from other validation rules)
            if(isRequired && validationProperties.hasOwnProperty("required")) {

                var conditions = {
                    not: {}
                };

                if(schemaProperty.ui.type === "text" || schemaProperty.ui.type === "date") {
                    conditions = {
                        not: {
                            type: "string",
                            minLength: 1
                        }
                    };
                } else if (schemaProperty.ui.type === "checkbox") {
                    conditions = {
                        not: {
                            const: true
                        }
                    };
                } else if (schemaProperty.ui.type === "single-select") {
                    conditions = {
                        not: {
                            type: "object"
                        }
                    };
                }

                var requiredValidator = generateValidationComponent(validationProperties.required, modelName, conditions);

                validators.push(requiredValidator);
            }

            //Handle other validation rules
            for (var validationRule in validationProperties) {
                //skip the "required" key as this one is a special one already handled before.
                if(validationRule === "required") continue;
                var tempConditions = {not: {}};

                if(validationProperties.hasOwnProperty(validationRule)) {
                    if(typeof validationProperties[validationRule] ===  "string") {


                        tempConditions.not[validationRule] = schemaProperty[validationRule];

                        if(isRequired && schemaProperty.type === "string") {
                            tempConditions['minLength'] = 1;
                        }

                        var tempValidator = generateValidationComponent(validationProperties[validationRule], modelName, tempConditions);

                        validators.push(tempValidator);

                    } else if (typeof validationProperties[validationRule] ===  "object") {
                        for(var rule in validationProperties[validationRule]) {
                            if(validationProperties[validationRule].hasOwnProperty(rule)) {

                                tempConditions.not[rule] = schemaProperty.properties[validationRule][rule];

                                tempValidator = generateValidationComponent(validationProperties[validationRule][rule], modelName + "." + validationRule, tempConditions);

                                validators.push(tempValidator);
                            }
                        }
                    } else {
                        log("Warning: Unknown validation type. Skipping.");
                    }
                }
            }

            return validators;
        }

        function generateHiddenComponent(schemaProperty, isRequired) {
            //schemaProperty MAY contain the following keys: default

            log("HiddenFieldComponent triggered.");

            var hiddenFieldComponent = new UIComponent("input");

            hiddenFieldComponent.addRootProperty("model", schemaProperty.elementId);
            hiddenFieldComponent.addFieldOption("ref", "component-" + schemaProperty.elementId);

            hiddenFieldComponent.addFieldOptionAttribute("type", "hidden");
            hiddenFieldComponent.addFieldOption("ref", "ref-" + schemaProperty.elementId);

            hiddenFieldComponent.addFieldOption("on", ["input"]);

            if(schemaProperty.hasOwnProperty("default")) {
                model[schemaProperty.elementId] = schemaProperty.default;
            }

            var validationComponents = generateValidationComponents(schemaProperty, schemaProperty.elementId, isRequired);
            hiddenFieldComponent.addChildren(validationComponents);

            return hiddenFieldComponent;
        }

        function generateOfferPageComponent(schemaProperty, isRequired) {
            log("OfferPageComponent triggered.");
            var offerPageComponent = new UIComponent("offer-page");

            offerPageComponent.addFieldOptionProperty("payload", payload);
            offerPageComponent.addFieldOptionProperty("globalData", globalData);

            offerPageComponent.addFieldOption("on", {"submitStep": function() {EventBus.$emit('submitStep')}, "skipStep": function() {EventBus.$emit('skipStep')}});

            return offerPageComponent;
        }

        function generateTextFieldComponent(schemaProperty, isRequired) {
            //schemaProperty MUST contain the following keys: ui, triggerRefresh
            //schemaProperty MAY contain the following keys: default, ui.classNames, ui.prefix, ui.suffix, ui.placeholder, ui.disabled, ui.label, ui.tooltip

            log("TextFieldComponent triggered.");

            if(!schemaProperty.hasOwnProperty("ui") || !schemaProperty.hasOwnProperty("triggerRefresh")) {
                log("TextFieldComponent '" + schemaProperty.elementId + "' does not provide mandatory information: ui / triggerRefresh");
                return false;
            }

            var textfieldComponent = new UIComponent("q-input");

            textfieldComponent.addRootProperty("model", schemaProperty.elementId);
            textfieldComponent.addFieldOption("ref", "component-" + schemaProperty.elementId);

            if(schemaProperty.ui.type === "number") {
                textfieldComponent.addFieldOptionAttribute("type", "number");
            }

            textfieldComponent.addFieldOptionAttribute("bottom-slots", true);

            textfieldComponent.addErrorOptionProperty("error", true);
            textfieldComponent.addErrorOptionProperty("bottom-slots", true);

            textfieldComponent.addFieldOption("nativeOn", ["input"]);

            if(schemaProperty.triggerRefresh) {
                textfieldComponent.addFieldOption("on",
                    { "blur":
                        function(event) {
                            EventBus.$emit('refresh');
                            return event.target.value;
                        }
                    }
                );
            }

            if(schemaProperty.hasOwnProperty("default")) {
                model[schemaProperty.elementId] = schemaProperty.default;
            }

            if(schemaProperty.ui.hasOwnProperty("classNames")) {
                textfieldComponent.addFieldOption("class", schemaProperty.ui.classNames);
            }

            if(schemaProperty.ui.hasOwnProperty("prefix")) {
                textfieldComponent.addFieldOptionAttribute("prefix", schemaProperty.ui.prefix);
            }

            if(schemaProperty.ui.hasOwnProperty("suffix")) {
                textfieldComponent.addFieldOptionAttribute("suffix", schemaProperty.ui.suffix);
            }

            if(schemaProperty.ui.hasOwnProperty("placeholder")) {
                textfieldComponent.addFieldOptionAttribute("placeholder", schemaProperty.ui.placeholder);
            }

            if(schemaProperty.ui.hasOwnProperty("disabled")) {
                textfieldComponent.addFieldOptionAttribute("disabled", schemaProperty.ui.disabled);
            }

            if(schemaProperty.ui.hasOwnProperty("label")) {
                let label = schemaProperty.ui.label;
                label = isRequired ? label + " *" : label;
                textfieldComponent.addFieldOptionAttribute("label", label);
            }

            var validationComponents = generateValidationComponents(schemaProperty, schemaProperty.elementId, isRequired);
            textfieldComponent.addChildren(validationComponents);

            if(schemaProperty.ui.hasOwnProperty("tooltip")) {
                var tooltip = generateTooltipComponent(schemaProperty.ui.tooltip);

                if(tooltip) {
                    textfieldComponent.addChild(tooltip);
                }
            }

            return textfieldComponent;
        }

        function generateDateComponent(schemaProperty, isRequired) {
            //schemaProperty MUST contain the following keys: ui, triggerRefresh
            //schemaProperty MAY contain the following keys: default, ui.classNames, ui.prefix, ui.suffix, ui.placeholder, ui.disabled, ui.label, ui.tooltip

            log("DateComponent triggered.");

            if(!schemaProperty.hasOwnProperty("ui") || !schemaProperty.hasOwnProperty("triggerRefresh")) {
                log("DateComponent '" + schemaProperty.elementId + "' does not provide mandatory information: ui / triggerRefresh");
                return false;
            }

            var textfieldComponent = new UIComponent("q-input");

            textfieldComponent.addRootProperty("model", schemaProperty.elementId);
            textfieldComponent.addFieldOption("ref", "component-" + schemaProperty.elementId);
            textfieldComponent.addRootProperty("valueProp", "value");

            textfieldComponent.addFieldOptionAttribute("bottom-slots", true);

            textfieldComponent.addErrorOptionProperty("mask", "date");
            textfieldComponent.addErrorOptionProperty(":rules", "['date']");

            textfieldComponent.addErrorOptionProperty("error", true);
            textfieldComponent.addErrorOptionProperty("bottom-slots", true);

            textfieldComponent.addFieldOptionProperty("readonly", true);

            var proxyComponent = new UIComponent('q-popup-proxy');
            proxyComponent.addFieldOptionProperty("ref", "qDateProxy");
            proxyComponent.addFieldOptionProperty("transition-show", "scale");
            proxyComponent.addFieldOptionProperty("transition-hide", "scale");

            var dateComponent = new UIComponent('q-date');
            dateComponent.addRootProperty("model", schemaProperty.elementId);
            dateComponent.addFieldOptionProperty("mask", "DD.MM.YYYY");
            dateComponent.addFieldOptionProperty("title", schemaProperty.ui.label);
            dateComponent.addFieldOptionProperty("subtitle", " ");

            dateComponent.addFieldOption("on",
                { "input":
                    function(value) {
                        if(schemaProperty.triggerRefresh) {
                            EventBus.$emit('refresh');
                        }

                        // TODO: Access Refs here or via event?
                        //$refs.qDateProxy.hide()
                        return value;
                    }
                }
            );

            proxyComponent.addChild(dateComponent);
            textfieldComponent.addChild(proxyComponent);

            if(schemaProperty.hasOwnProperty("default")) {
                model[schemaProperty.elementId] = schemaProperty.default;
            }

            if(schemaProperty.ui.hasOwnProperty("classNames")) {
                textfieldComponent.addFieldOption("class", schemaProperty.ui.classNames);
            }

            if(schemaProperty.ui.hasOwnProperty("placeholder")) {
                textfieldComponent.addFieldOptionAttribute("placeholder", schemaProperty.ui.placeholder);
            }

            if(schemaProperty.ui.hasOwnProperty("label")) {
                let label = schemaProperty.ui.label;
                label = isRequired ? label + " *" : label;
                textfieldComponent.addFieldOptionAttribute("label", label);
            }

            var validationComponents = generateValidationComponents(schemaProperty, schemaProperty.elementId, isRequired);
            textfieldComponent.addChildren(validationComponents);

            if(schemaProperty.ui.hasOwnProperty("tooltip")) {
                var tooltip = generateTooltipComponent(schemaProperty.ui.tooltip);

                if(tooltip) {
                    textfieldComponent.addChild(tooltip);
                }
            }

            return textfieldComponent;
        }

        function generateCheckboxComponent(schemaProperty, isRequired) {
            //schemaProperty MUST contain the following keys: ui, triggerRefresh
            //schemaProperty MAY contain the following keys: default, ui.classNames, ui.disabled, ui.label

            log("CheckBoxComponent triggered.");

            if(!schemaProperty.hasOwnProperty("ui") || !schemaProperty.hasOwnProperty("triggerRefresh")) {
                log("CheckboxComponent '" + schemaProperty.elementId + "' does not provide mandatory information: ui / triggerRefresh");
                return false;
            }

            var fieldComponent = new UIComponent("q-field");

            fieldComponent.addRootProperty("model", schemaProperty.elementId);
            fieldComponent.addFieldOption("ref", "component-" + schemaProperty.elementId);

            fieldComponent.addErrorOptionAttribute("error", true);
            fieldComponent.addErrorOptionAttribute("bottom-slots", true);

            fieldComponent.addFieldOptionProperty("borderless", "borderless");
            fieldComponent.addFieldOptionProperty("stack-label", "stack-label");
            fieldComponent.addFieldOptionAttribute("bottom-slots", true);

            if(schemaProperty.ui.hasOwnProperty("classNames")) {
                fieldComponent.addFieldOption("class", schemaProperty.ui.classNames);
            }

            var checkboxComponent = new UIComponent("q-checkbox");

            checkboxComponent.addFieldOption("on",
                { "input":
                    function(value) {
                        if(schemaProperty.triggerRefresh) {
                            EventBus.$emit('refresh');
                        }

                        return value;
                    }
                }
            );

            checkboxComponent.addRootProperty("model", schemaProperty.elementId);

            checkboxComponent.addFieldOptionProperty("false-value", false);

            if(schemaProperty.hasOwnProperty("default")) {
                model[schemaProperty.elementId] = schemaProperty.default;
            } else {
                model[schemaProperty.elementId] = false;
            }

            if(schemaProperty.ui.hasOwnProperty("disabled")) {
                checkboxComponent.addFieldOptionAttribute("disabled", schemaProperty.ui.disabled);
            }

            if(schemaProperty.ui.hasOwnProperty("label")) {
                let label = schemaProperty.ui.label;
                label = isRequired ? label + " *" : label;
                checkboxComponent.addFieldOptionAttribute("label", label);
            }

            fieldComponent.addChild(checkboxComponent);

            var validationComponents = generateValidationComponents(schemaProperty, schemaProperty.elementId, isRequired);
            fieldComponent.addChildren(validationComponents);

            return fieldComponent;
        }

        function generateSelectComponent(schemaProperty, isRequired) {
            //schemaProperty MUST contain the following keys: ui, ui.options
            //schemaProperty MAY contain the following keys: default, ui.classNames, ui.disabled, ui.label, ui.tooltip

            log("SelectComponent triggered.");

            if(!schemaProperty.hasOwnProperty("ui") || !schemaProperty.hasOwnProperty("triggerRefresh")) {
                log("SelectComponent '" + schemaProperty.elementId + "' does not provide mandatory information: ui / triggerRefresh");
                return false;
            }

            if(!schemaProperty.ui.hasOwnProperty("options")) {
                log("SelectComponent '" + schemaProperty.elementId + "' does not provide mandatory information: ui.options");
                return false;
            }

            var selectComponent = new UIComponent("q-select");

            selectComponent.addRootProperty("model", schemaProperty.elementId);
            selectComponent.addFieldOption("ref", "component-" + schemaProperty.elementId);

            selectComponent.addFieldOptionAttribute("bottom-slots", true);

            selectComponent.addErrorOptionAttribute("error", true);
            selectComponent.addErrorOptionAttribute("bottom-slots", true);

            selectComponent.addFieldOptionAttribute("options", schemaProperty.ui.options);

            selectComponent.addFieldOption("on",
                { "input":
                    function(value) {
                        if(schemaProperty.triggerRefresh) {
                            EventBus.$emit('refresh');
                        }

                        return value;
                    }
                }
            );

            if(schemaProperty.hasOwnProperty("default")) {
                model[schemaProperty.elementId] = schemaProperty.default;
            }

            if(schemaProperty.ui.hasOwnProperty("classNames")) {
                selectComponent.addFieldOption("class", schemaProperty.ui.classNames);
            }

            if(schemaProperty.ui.hasOwnProperty("disabled")) {
                selectComponent.addFieldOptionAttribute("disabled", schemaProperty.ui.disabled);
            }

            if(schemaProperty.ui.hasOwnProperty("label")) {
                let label = schemaProperty.ui.label;
                label = isRequired ? label + " *" : label;
                selectComponent.addFieldOptionAttribute("label", label);
            }

            var validationComponents = generateValidationComponents(schemaProperty, schemaProperty.elementId, isRequired);
            selectComponent.addChildren(validationComponents);

            if(schemaProperty.ui.hasOwnProperty("tooltip")) {
                var tooltip = generateTooltipComponent(schemaProperty.ui.tooltip);

                if(tooltip) {
                    selectComponent.addChild(tooltip);
                }
            }

            return selectComponent;
        }

        function generateFileComponent(schemaProperty, isRequired) {
            //schemaProperty MUST contain the following keys: ui, triggerRefresh
            //schemaProperty MAY contain the following keys: default, ui.classNames, ui.label, ui.icon

            log("FileComponent triggered.");

            if(!schemaProperty.hasOwnProperty("ui") || !schemaProperty.hasOwnProperty("triggerRefresh")) {
                log("FileComponent '" + schemaProperty.elementId + "' does not provide mandatory information: ui / triggerRefresh");
                return false;
            }

            var fileComponent = new UIComponent("q-file");

            fileComponent.addRootProperty("model", schemaProperty.elementId);
            fileComponent.addFieldOption("ref", "component-" + schemaProperty.elementId);

            fileComponent.addFieldOptionAttribute("bottom-slots", true);
            fileComponent.addFieldOptionProperty("stack-label", "stack-label");
            fileComponent.addFieldOptionProperty("clearable", "clearable");

            fileComponent.addErrorOptionAttribute("error", true);
            fileComponent.addErrorOptionAttribute("bottom-slots", true);

            fileComponent.addFieldOption("on",
                {
                    "input":
                        function (value) {
                            if (schemaProperty.triggerRefresh) {
                                EventBus.$emit('refresh');
                            }

                            return value;
                        }
                }
            );

            /*
            * Default values for input type file has to be handled different
             */
            if(schemaProperty.hasOwnProperty("default")) {
                /*
                 * If a default value is submitted, the form field value will not be prefilled with this information as
                 * this is only a link to the already uploaded file on the server. Instead a hint will be displayed where
                 * a user can navigate to the file on the server.
                 */
                var hintComponent = new UIComponent("span");
                hintComponent.addFieldOption("slot", "hint");
                let filename = schemaProperty.default.substring(schemaProperty.default.lastIndexOf('/')+1);
                hintComponent.addFieldOption("domProps", {"innerHTML": "Sie haben bereits eine Datei hochgeladen: <a href='" + schemaProperty.default + "'>" + filename + "</a>"});
                fileComponent.addChild(hintComponent);

                /*
                 * If a file has already been uploaded, this field is not threatened as mandatory anymore
                 * (but unfortunately it is displayed with a * in the field label)
                 */
                const index = schema.required.indexOf(schemaProperty.elementId);
                if (index > -1) {
                    schema.required.splice(index, 1);
                }
            }

            if(schemaProperty.ui.hasOwnProperty("classNames")) {
                fileComponent.addFieldOption("class", schemaProperty.ui.classNames);
            }

            if(schemaProperty.ui.hasOwnProperty("label")) {
                let label = schemaProperty.ui.label;
                label = isRequired ? label + " *" : label;
                fileComponent.addFieldOptionAttribute("label", label);
            }

            /*
             * If a file field provides a default value, it means, a file has already been uploaded. Thus the field is
             * not required anymore. Setting isRequired to false just skips adding the validation components.
             */
            if(schemaProperty.hasOwnProperty("default")) {
                isRequired = false;
            }
            var validationComponents = generateValidationComponents(schemaProperty, schemaProperty.elementId, isRequired);
            fileComponent.addChildren(validationComponents);

            if(schemaProperty.ui.hasOwnProperty("icon")) {

                /*
                 * Beside to the beforementioned link, if a file has already been uploaded, a preview of the uploaded
                 * file should be displayed instead of an icon (only for picture formats)
                 */
                var displayablePictureFormats = ["png", "gif", "jpg", "jpeg"];
                if(schemaProperty.hasOwnProperty("default") && displayablePictureFormats.includes((schemaProperty.default.split('.').pop()).toLowerCase())) {
                    var previewImage = new UIComponent("img");

                    previewImage.addFieldOption("slot", "before");
                    previewImage.addFieldOptionAttribute("src", schemaProperty.default);
                    previewImage.addFieldOptionAttribute("width", "24");
                    previewImage.addFieldOptionAttribute("height", "24");

                    fileComponent.addChild(previewImage);
                } else {
                    var iconComponent = new UIComponent("q-icon");

                    iconComponent.addFieldOption("slot", "before");
                    iconComponent.addFieldOptionProperty("name", schemaProperty.ui.icon);

                    fileComponent.addChild(iconComponent);
                }
            }

            return fileComponent;
        }

        Vue.prototype.$convertJSONSchema = function(originalSchema, originalPayload, originalGlobalData) {
            model = {};
            schema = originalSchema;
            payload = originalPayload;
            globalData = originalGlobalData;

            generateUISchemaWrapper();

            initializeFormFields(originalSchema);

            log([uiSchema.getUISchema()]);

            return {
                "model": model,
                "uiSchema": [uiSchema.getUISchema()],
                "schema": schema
            };
        }
    }
};

export default ElioJSONSchemaConverter;